import { sortByCustomOrder } from "../../common/Helper";
import CheckoutInput from "../../components/CheckoutInput";

const Booking = ({
    user,
    state,
    changeValue,
    showPassword,
    getClassNames,
    handhandleShowPassword,
    mainContactField,
    passengerField,
    passengers,
    handleCountrySelectChange,
    handleChangeMainContact,
    onChangeCustomDropdown,
    onChangeDate,
    handleLanguageSelectChange,
    handleNumberChange,
    handleValidityChange,
    handleChangePassenger,
    isLoading,
    isLoginForm,
    setIsLoginForm,
}) => {
    const { error, email, password, first_name, last_name } = state;
    const chunkArray = (array, size) => {
        return array.reduce((acc, _, i) =>
            (i % size ? acc : [...acc, array.slice(i, i + size)]), []
        );
    };
    const groupedFields = chunkArray(sortByCustomOrder(mainContactField), 2); // Group into pairs

    // console.log(passengers);

    return (
        <div className="wizard-booking">
            {
                !user?.token &&

                <div className="registerBox checkout-form">
                    <div class="accessibleBox">
                        <div class="ourClickBox">
                            <div class="typecheck">
                                <input type="radio" id="is_wheelchair_accessible_no" name="is_wheelchair_accessible" class="form-check-input" onChange={() => setIsLoginForm(true)} checked={isLoginForm} />
                                <label for="" class="keyword-label">Login</label>
                            </div>
                            <div class="typecheck">
                                <input type="radio" id="is_wheelchair_accessible_yes" name="is_wheelchair_accessible" onChange={() => setIsLoginForm(false)} class="form-check-input" checked={!isLoginForm} />
                                <label for="" class="keyword-label">Registration</label>
                            </div>
                        </div>
                    </div>
                    <h5>Fast & easy {isLoginForm ? "Login" : "Registration"}</h5>
                    {
                        !isLoginForm &&
                        <>
                        <div className="form-group mb-4">
                        <label for="">First Name
                            <font className="req-sym">*</font>
                        </label>
                        <input
                            className="commonInputSecond"
                            type="text"
                            placeholder="First Name"
                            name="first_name"
                            id="first_name"
                            value={first_name}
                            onChange={changeValue}
                        />
                        {error && error.first_name && <span className="cus-err">{error.first_name}</span>}

                    </div>
                    <div className="form-group my-4">
                        <label for="">Last Name
                            <font className="req-sym">*</font>
                        </label>
                        <input
                            className="commonInputSecond"
                            type="text"
                            placeholder="Last Name"
                            name="last_name"
                            id="last_name"
                            value={last_name}
                            onChange={changeValue}
                        />
                        {error && error.last_name && <span className="cus-err">{error.last_name}</span>}

                    </div>
                        </>
                    }
                    
                    <div className="form-group">
                        <label for="">Email
                            <font className="req-sym">*</font>
                        </label>
                        <input
                            className="commonInputSecond"
                            type="email"
                            placeholder="jhondoe@gmail.com"
                            name="email"
                            id="email"
                            value={email}
                            onChange={changeValue}
                        />
                        {error && error.email && <span className="cus-err">{error.email}</span>}

                    </div>
                    <div className="form-group my-4">
                        <label for="">Password
                            <font className="req-sym">*</font>
                        </label>
                        <input
                            className="commonInputSecond"
                            type={!showPassword ? 'password' : 'text'}
                            name="password"
                            id="password"
                            value={password}
                            onChange={changeValue}
                            placeholder="&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;&#9679;"
                        />
                        <button className="btn btnShow">
                            {
                                showPassword ? <i className="fa-solid fa-eye-slash" onClick={(e) => handhandleShowPassword(e)}></i> : <i className="fa-solid fa-eye" onClick={(e) => handhandleShowPassword(e)}></i>
                            }
                        </button>
                        {error && error.password && <span className="cus-err">{error.password}</span>}
                        <div className="lineSpan">
                            <span className={getClassNames(0)}></span>
                            <span className={getClassNames(1)}></span>
                            <span className={getClassNames(2)}></span>
                        </div>
                    </div>

                </div>
            }


            {
                groupedFields.length > 0 &&

                <div className="payCradBox">
                    <h5 className={`${isLoading ? "skeleton customTitle" : "customTitle"}`}>Main traveller's contact details</h5>
                </div>
            }
            {
                groupedFields.length > 0 &&

                <div className={`${isLoading ? "skeleton fillNewbox checkout-form" : "fillNewbox checkout-form"}`} style={{ minHeight: "200px" }}>

                    {groupedFields.map((group, index) => (
                        <div className="innerFormBox " key={index}>
                            {group.map((field, idx) => (
                                <CheckoutInput
                                    type={field.field_name}
                                    field={field}
                                    idx={idx}
                                    handleCountrySelectChange={handleCountrySelectChange}
                                    handleChangeMainContact={handleChangeMainContact}
                                    onChangeCustomDropdown={onChangeCustomDropdown}
                                    onChangeDate={onChangeDate}
                                    handleLanguageSelectChange={handleLanguageSelectChange}
                                    handleNumberChange={handleNumberChange}
                                    handleValidityChange={handleValidityChange}
                                    form={'MAIN_CONTACT'}
                                />
                            ))}
                            {/* If odd, add an empty div to maintain layout alignment */}
                            {group.length === 1 && <div className="box-box empty-box"></div>}
                        </div>
                    ))}
                </div>
            }

            {
                passengerField.length > 0 &&
                <div className="personalDetails">
                    <div className="payTitle">
                        <h5 className="customTitle">Booking Questions</h5>
                    </div>
                    {passengers.map((passenger) => {
                        const groupedFields = chunkArray(sortByCustomOrder(passenger.fields), 2);

                        return (
                            <div className="passengerBox" key={passenger.id}>
                                <h4 className="commonLabelSecond checkoutsublabels">{passenger?.cat == 'GROUP' ? 'Group' : "Passenger"} {passenger.id} ({passenger.type})</h4>
                                <div className="fillNewbox checkout-form">
                                    {groupedFields.map((group, index) => (
                                        <div className="innerFormBox" key={index}>
                                            {group.map((field, idx) => (
                                                <CheckoutInput
                                                    type={field.field_name}
                                                    field={field}
                                                    idx={idx}
                                                    handleCountrySelectChange={handleCountrySelectChange}
                                                    handleChangeMainContact={handleChangePassenger}
                                                    onChangeCustomDropdown={onChangeCustomDropdown}
                                                    handleLanguageSelectChange={handleLanguageSelectChange}
                                                    handleNumberChange={handleNumberChange}
                                                    handleValidityChange={handleValidityChange}
                                                    passenger={passenger}
                                                    onChangeDate={onChangeDate}
                                                    form={'PASSENGER'}
                                                />

                                            ))}
                                            {group.length === 1 && <div className="box-box empty-box"></div>}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        );
                    })}
                </div>
            }

        </div>
    )

}
export default Booking